import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PlatformPengyouquan"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M16.0373 9.43403V2.89375C16.0373 2.89375 12.8357 1.17804 9.09831 2.50093L16.0373 9.43403ZM16.6434 13.2817V3.16381C16.6434 3.16381 20.4283 4.87839 21.4949 9.0435L16.6434 13.2817ZM14.6073 16.2226L21.5943 9.6544C21.5943 9.6544 22.8306 11.6636 20.987 16.2226H14.6073ZM11.0396 17.0554H20.4763C20.4763 17.0554 19.3371 20.1419 15.2597 21.4163L11.0396 17.0554ZM7.95911 14.9717V21.1206C7.95911 21.1206 10.41 22.6895 14.6073 21.6361L7.95911 14.9717ZM2.49978 15.2897L7.2798 11.0024V20.7524C7.2798 20.7523 4.39192 19.7503 2.49978 15.2897ZM2.37864 14.604C2.37864 14.604 1.28522 11.0772 2.81455 8.01407H9.38908L2.37864 14.604ZM3.22761 7.32666C3.22761 7.32666 4.61073 4.19208 8.37104 2.72133L12.8586 7.32666H3.22761Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PlatformPengyouquan.vue"]]);
